if ($.fn.flexslider) {
    $('.twitter-slider').flexslider({
        animation: "slide",
        directionNav: false,

    });
};
